/* import __COLOCATED_TEMPLATE__ from './add-screen.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();